import _ from 'lodash';
import React, { useContext } from 'react';
import { LayoutContext } from 'contexts/LayoutContext';
import { CreateCardAccountStackRoutes, CreateCardAccountStackScreenProps } from './type';

import { SelectAccountWebScreen } from './SelectAccountWeb.screen';
import { SelectAccountNativeScreen } from './SelectAccountNative.screen';

export interface SelectAccountScreenProps {}

export const SelectAccountScreen: React.FC<CreateCardAccountStackScreenProps<CreateCardAccountStackRoutes.SelectAccount>> = ({
  navigation,
  route
}) => {
  const layout = useContext(LayoutContext);
  const { onLayout, onSelect, onChangeView, borderRadiusFlag } = route.params;

  if (layout.isMobile) {
    return <SelectAccountNativeScreen onSelect={onSelect} />;
  }
  return <SelectAccountWebScreen onLayout={onLayout} onSelect={onSelect} onChangeView={onChangeView} borderRadiusFlag={borderRadiusFlag} />;
};
